import React, { useState, useEffect } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import mime from "mime-types";
import styles from "./styles";
import LoadingIndicator from "../../../../Component/LoadingIndicator";
import { httpGetF } from "../../../../API/Http";
import Preview from "./components/preview";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(styles);

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: 0,
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
  },
}))(MuiDialogActions);

const FilePreviewDialog = ({ isDialogOpen, onClose, document }) => {
  const classes = useStyles();
  const [isLoading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [mimeType, setMimeType] = useState("");
  const [binaryData, setBinaryData] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    const fetchDocument = async () => {
      try {
        setIsError(false);
        setLoading(true);
        const response = await httpGetF("/entity/document", {
          documentId: document.id,
          entityId: document.entity_id,
          category: document.category,
        });
        setBinaryData(response);
        setLoading(false);
      } catch (e) {
        setBinaryData("");
        setLoading(false);
      }
    };
    setMimeType(mime.lookup(document.filename));
    fetchDocument();
  }, []);

  const handleClose = () => {
    if (onClose !== undefined && typeof onClose === "function") {
      onClose();
    }
  };

  const renderLoadingIndicator = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "70vh",
        }}
      >
        <LoadingIndicator />
      </div>
    );
  };

  return (
    <Dialog
      disableBackdropClick
      classes={{ paper: classes.dialogPaper }}
      onClose={handleClose}
      aria-labelledby="add-document-modal"
      open={isDialogOpen}
      fullWidth={true}
      fullScreen={true}
    >
      <DialogTitle id="add-document-modal" onClose={handleClose}>
        <Typography className={classes.panelTitle}>
          {t("labels.record.documents.prevDocument", {
            docFilename: document.filename,
          })}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        {isLoading ? (
          renderLoadingIndicator()
        ) : !isError ? (
          <Preview
            fileName={document.filename}
            binaryData={binaryData}
            mimeType={mimeType}
          ></Preview>
        ) : (
          isError
        )}
      </DialogContent>
      <DialogActions>
        <Button
          label={t("labels.common.close")}
          theme="secondary"
          onClick={handleClose}
        />
      </DialogActions>
    </Dialog>
  );
};

export default FilePreviewDialog;
